import React, { Component } from 'react';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	FormGroup,
	Label,
	Input,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import MessagePage from '../../views/MessagePage/';

class Group extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			radi: '',
			classs: [],
			groupmember: [],
			grpmember: [],
			grpmembers: [],
			cls: '',
			section: '',
			typecheck: '',
			dept: '',
			mobile: '',
			singlemessage: '',
			textmessage: '',
			_message: '',
			value: [],
			sections: [],
			group: [],
			groups: [],
			employee: '',
			type: '',
			gtype: '',
			isUnicode: 0,
			isUnicode1: 0,
			alertClass: '',
			_redirect: false,
			loading: false,
			posts: [],
			stud: [],
			emp: [],
			depart: [],
			modal: false,
			studdata: [],
			empdata: [],
			stdcount: '',
			empcount: '',
			sec: [],
			scount: 0,
			namecheck: 0,
			sendway: '3',
			smstemp: [],
			accyear: [],
			acyear: '',
			studdet: [],
			student: '',
			department: [],
			depat: [],
			clas: [],
			grops: [],
			secstd: [],
			std: [],
			userId: JSON.parse(sessionStorage.getItem('userData')).userid
		}
		this.basestate = this.state;
		this.onAcYearChange = this.onAcYearChange.bind(this);
		this.onChkChange = this.onChkChange.bind(this);
		this.onChkChange1 = this.onChkChange1.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onNameChange = this.onNameChange.bind(this);
		this.onOptChange = this.onOptChange.bind(this);
		this.onSendChange = this.onSendChange.bind(this);
		this.onClssChange = this.onClssChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		// this.otherSubmit = this.otherSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
		this.handleGroupChange = this.handleGroupChange.bind(this);
		this.handleStudChange = this.handleStudChange.bind(this);
		this.handleDeptChange = this.handleDeptChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.toggle = this.toggle.bind(this);
		this.onSingleChange = this.onSingleChange.bind(this);
	}

	onChkStudChange(e){
		$("#countid").html('0 Students');
		$("#countid1").html('0 Push Notification');
		if(e.target.checked){
			this.state.std = [];

			var stud1 = this.state.studdet.map(function (e, key) {
				return (
					{ value: e.regno, label: e.stdname }
				);
			});

			{
				this.state.studdet.map(item =>

					this.state.std.push(item.regno)
				)
			}
			this.setState({ student: stud1,std : this.state.std });
			this.countdata();
		}
		else{
			this.state.std = [];
			this.setState({ student: [] ,std : this.state.std});
			this.countdata();
		}

	}

	onAcYearChange(e){
		this.setState({
			acyear: e.target.value
		});
		this.state.acyear = e.target.value;
		this.getstud();
		this.getallocatesection();
	}

	onSingleChange(e) {
		this.setState({ [e.target.name]: e.target.value });
	}

	toggle() {
		this.setState({
			modal: !this.state.modal
		});
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		if (this.state.radi != '4' && this.state.radi != '7') {
			this.getstudentdet();
		}
		else if (e.target.name == 'gtype') {
			this.checkgroupmembers(e.target.value);
		}
	}

	checkgroupmembers(val) {

		var dat = [];
		for (var i = 0; i < this.state.groupmember.length; i++) {

			if (this.state.groupmember[i].type == val) {
				dat.push(this.state.groupmember[i]);
			}
		}
		this.setState({ grpmembers: dat });
	}

	onNameChange(e) {
		if (e.target.checked) {

			this.state.namecheck = 1;
		}
		else {

			this.state.namecheck = 0;
		}
	}

	onSendChange(e) {

		this.setState({ sendway: e.target.value });
	}

	/** set value **/
	onOptChange(e) {

		$("#clas").val('');
		$("#utype").val('');
		$("#secs").val('');
		$("#countid").html('');
		this.setState({ depart: [], sec: [], studdet: [], classs: [], department: [], value: [], student: [], type: '', secstd: [], std: [], clas: [], depat: [], cls: '' });
		this.setState({ [e.target.name]: e.target.value });
		if (e.target.value != '5') {
			this.getstudentdet();
			this.getstud();
			this.getemployee();
			this.getdepartment();
		}
	}

	onChkChange(e) {

		if (e.target.checked) {
			this.setState({ isUnicode1: 1 });
			this.state.isUnicode1 = 1;
		}
		else {
			this.setState({ isUnicode1: 0 });
			this.state.isUnicode1 = 0;
		}
	}

	onChkChange1(e) {

		if (e.target.checked) {
			this.setState({ isUnicode: 1 });
			this.state.isUnicode = 1;
		}
		else {
			this.setState({ isUnicode: 0 });
			this.state.isUnicode = 0;
		}
	}

	onClssChange(e) {
		this.setState({ [e.target.name]: e.target.value, sec: [], section: '', value: [] });
		$("#secs").val('');
		this.getsection();
	}

	onClick(e) {
		document.getElementById("subform").reset();
	}

	/** set value to react select **/
	handleChange(value) {

		this.state.secstd = [];
		{
			value.map(item =>

				this.state.secstd.push(item.value)
			)
		}
		this.setState({ value });
		this.countdata();
	}

	handleStudChange(value) {

		this.state.std = [];
		{
			value.map(item =>

				this.state.std.push(item.value)
			)
		}
		this.setState({ student: value });
		
		this.countdata();
	}

	handleDeptChange(value) {

		this.state.depat = [];
		{
			value.map(item =>

				this.state.depat.push(item.label)
			)
		}
		this.setState({ department: value });
		this.countdata();
	}

	handleMemChange(value) {

		this.state.grpmember = [];
		{
			value.map(item =>

				this.state.grpmember.push(item.value)
			)
		}
		this.setState({ grpmem: value });
		this.countdata();
	}

	/** set value to react select **/
	handleSelectChange(value) {

		this.state.clas = [];
		{
			value.map(item =>

				this.state.clas.push(item.value)
			)
		}
		this.setState({ classs: value });
		this.countdata();
	}

	handleGroupChange(e) {
		this.setState({ group: e.target.value, gtype: '', grpmembers: [] });
		$("#gtype").val('');
		$("#countid").html('');
		this.getgroupmembers(e.target.value);
	}

	clear() {

		this.state.mobile = '';
		this.state.singlemessage = '';
		this.state.textmessage = '';
		this.state.value = [];
		this.state.student = [];
		this.state.classs = [];
	}

	checkformsubmit() {

		if (this.state.radi == '') {

			alert('Select Category!..');
			return false;
		}
		else {

			if (this.state.radi == '1' && this.state.classs == '') {

				alert('Select Class!..');
				return false;

			}
			else if (this.state.radi == '2' && this.state.cls == '') {

				alert('Class and Section Cannot be empty!..');
				return false;

			}
			else if (this.state.radi == '2' && this.state.secstd == '') {

				alert('Class and Section Cannot be empty!..');
				return false;

			}
			else if (this.state.radi == '3' && this.state.cls == '') {

				alert('Class and Section and Student Cannot be empty!..');
				return false;
			}
			else if (this.state.radi == '3' && this.state.section == '') {

				alert('Class and Section and Student Cannot be empty!..');
				return false;
			}
			else if (this.state.radi == '3' && this.state.std == '') {

				alert('Class and Section and Student Cannot be empty!..');
				return false;
			}
			else if (this.state.radi == '4' && this.state.type == '') {

				alert('Select type!..');
				return false;
			}
			else if (this.state.radi == '6' && this.state.depat == '') {

				alert('Select Department!..');
				return false;
			}
			else {

				return true;

			}
		}
	}

	onSubmit(e) {
		e.preventDefault();

		if (this.checkformsubmit()) {

			if (this.state.textmessage != '' || this.state.singlemessage != '') {

				PostData('message/groupsms', this.state).then((result) => {
					let responseJson = result;
					if (responseJson.status == '1') {
					}
					else {

						this.setState({
							_message: 'Invalid Key',
							alertClass: 'alert alert-danger'
						});
					}
				});

				this.setState({
					modal: false
				});
				$("#some_div").hide();
				$("#time").show();

				var timeLeft = 10;
				var elem = document.getElementById('time');
				var timerId = setInterval(countdown, 1000);
				function countdown() {
					if (timeLeft == 0) {
						clearTimeout(timerId);
						$("#some_div").show();
						$("#time").hide();
						alert('SMS Send Successfully!..');
					} else {
						elem.innerHTML = timeLeft + ' seconds remaining';
						timeLeft--;
					}
				}

				document.getElementById("smsform").reset();
				this.clear();
				this.getacyear();
				$("#countid").html('');
			}
			else {
				alert('Message Cannot be Empty!..');
			}
		}
	}

	handleClick(dd) {

		this.state.id = dd;
		if (window.confirm("Do you want to Delete?")) {
			$("#showLoader").show();
			PostData('message/deletsmstemp', this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if (responseJson.status == '1') {
					this.setState({
						_message: 'SMS Template Removed Successfullly',
						alertClass: 'alert alert-success'
					});
					this.getdata();
				}
				else {
					this.setState({
						_message: 'Error',
						alertClass: 'alert alert-danger'
					});
				}
			});
		}
	}

	onUpdate(dt) {
		this.state.idd = dt;
		this.setState({ _redirect: true });
	}

	componentWillMount() {

		this.getemployee();
		this.getdepartment();
		this.getsmstemplate();
		this.getacyear();
		this.getclass();
		this.getgroups();
	}

	/** get Academic Year **/
	getacyear() {

		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				this.getstud();
				this.getallocatesection();
			}
		});
	}

	getgroupmembers(id) {
		GetData('group/getgroupmembersbyid/' + id).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					groupmember: responseJson
				});
			}
		});
	}

	getgroups() {
		GetData('group/getgroup').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					groups: responseJson
				});
			}
		});
	}

	checkname() {

		if (this.state.nam == 1) {
			$("#isdisplayUp").prop("checked", true);
		}
		if (this.state.isdisplay == 0) {
			$("#isdisplayUp").prop("checked", false);
		}
	}

	getdepartment() {

		GetData('designation/getdesignation').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					depart: responseJson
				});
			}
		});
	}

	getsmstemplate() {
		$("#showLoader").show();
		GetData('message/getsmstemp').then((result) => {
			$("#showLoader").hide();
			let res = result;
			if (res) {
				this.setState({
					smstemp: res
				});
			}
		});
	}

	getemployee() {

		GetData('employee/getemployee').then((result) => {
			let res = result;
			if (res) {
				this.setState({
					empdata: res
				});
				this.setState({ empcount: this.state.empdata.length });
				this.getempappcount();
			}
		});
	}

	getempappcount() {
		var count = 0;
		for (var i = 0; i < this.state.empdata.length; i++) {
			if (this.state.empdata[i].appid != null) {
				count += 1;
			}
		}
		this.setState({ empcountapp: count });
	}

	//get allocate section details
	getallocatesection() {

		GetData('section/getsecbyacyear/' + this.state.acyear).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	//get Student Details
	getstud() {
		$("showLoader").show();
		GetData('student/getstuddetails/' + this.state.acyear).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					studdata: responseJson
				});
				this.setState({ stdcount: this.state.studdata.length });
				this.getappcount();
				$("#showLoader").hide();
			}
		});
	}

	getappcount() {
		var count = 0;
		for (var i = 0; i < this.state.studdata.length; i++) {
			if (this.state.studdata[i].appid != null) {
				count += 1;
			}
		}
		this.setState({ stdcountapp: count });
	}

	// Get Student Details by class
	getstudentdet() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		GetData('student/getstddetailsbymsg/' + ac + '/' + cls + '/' + sec).then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					studdet: responseJson
				});
				this.setState({ stdcount: this.state.studdet.length });
			}
		});
	}

	/** get Class **/
	getclass() {

		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}

	// Get Section By Class
	getsection() {
		var fr = $("#clas").val();
		var dat = [];
		if (fr != '') {
			for (var i = 0; i < this.state.sections.length; i++) {

				if (this.state.sections[i].clas == fr) {
					dat.push(this.state.sections[i]);
				}
			}
		}
		this.setState({ sec: dat });
	}

	onAddTemp(mess) {

		this.state.textmessage = mess;
		$("#msgarea").val(mess);
	}

	countdata() {


		this.state.postFilter = [];

		if (this.state.depat.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.empdata;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.depat.indexOf(l.designame) != -1);
			});
			$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
			if (this.state.sendway == 3) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.depat.indexOf(l.designame) != -1 && l.appid != null);
				});
				$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
			else if (this.state.sendway == 2) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.depat.indexOf(l.designame) != -1 && l.appid != null);
				});
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
		}
		if (this.state.clas.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.studdata;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.clas.indexOf(l.class) != -1);
			});
			$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
			if (this.state.sendway == 3) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.clas.indexOf(l.class) != -1 && l.appid != null);
				});
				$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
			else if (this.state.sendway == 2) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.clas.indexOf(l.class) != -1 && l.appid != null);
				});
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
		}
		if (this.state.grpmember.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.grpmembers;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.grpmember.indexOf(l.memberid) != -1);
			});
			$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
			if (this.state.sendway == 3) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.grpmember.indexOf(l.memberid) != -1 && l.appid != null);
				});
				$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
			else if (this.state.sendway == 2) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.grpmember.indexOf(l.memberid) != -1 && l.appid != null);
				});
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
		}
		if (this.state.secstd.length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.studdata;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.secstd.indexOf(l.section) != -1 && this.state.cls == l.class);
			});
			$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
			if (this.state.sendway == 3) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.secstd.indexOf(l.section) != -1 && this.state.cls == l.class && l.appid != null);
				});
				$("#countid").html(this.state.postFilter.length + ' ' + ' Students');
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
			else if (this.state.sendway == 2) {
				this.state.postFilter1 = this.state.postFilter.filter(l => {
					return (this.state.secstd.indexOf(l.section) != -1 && this.state.cls == l.class && l.appid != null);
				});
				$("#countid1").html(this.state.postFilter1.length + ' ' + ' Push Notification');
			}
		}
		if (Object.keys(this.state.std).length > 0) {
			if (this.state.postFilter.length < 1) {

				this.state.postFilter = this.state.studdata;
			}
			this.state.postFilter = this.state.postFilter.filter(l => {
				return (this.state.std.indexOf(l.regno) != -1 && this.state.cls == l.class && this.state.section == l.section);
			});
			/*$("#countid").html(this.state.postFilter.length+' '+' SMS');
			if(this.state.sendway == 3){
				this.state.postFilter1 = this.state.postFilter.filter(l => {
				   return (this.state.std.indexOf(l.regno) !=-1 && this.state.cls == l.class && this.state.section == l.section && l.appid!=null) ;
				});
				$("#countid").html(this.state.postFilter.length+' '+' SMS');
				$("#countid1").html(this.state.postFilter1.length+' '+' Push Notification');
			}
			else if(this.state.sendway == 2){
				this.state.postFilter1 = this.state.postFilter.filter(l => {
				   return (this.state.std.indexOf(l.regno) !=-1 && this.state.cls == l.class && this.state.section == l.section && l.appid!=null) ;
				});
				$("#countid1").html(this.state.postFilter1.length+' '+' Push Notification');
			}*/
			var count = 0
			$("#countid").html((this.state.student.length + 1) + ' ' + ' Students');
			for (var i = 0; i < this.state.student.lenght; i++) {
				for (var j = 0; j < this.state.postFilter.length; j++) {
					if (this.state.student[i].value == this.state.postFilter[j].regno && this.state.postFilter[j].appid != null) {
						count += 1;
					}
				}
			}
			$("#countid1").html(count + ' ' + ' Push Notification');
		}

	}

	getgrpmemcount() {
		var count = 0;
		for (var i = 0; i < this.state.groupmember.length; i++) {
			if (this.state.groupmember[i].type == this.state.gtype) {
				count += 1;
			}
		}
		return count;
	}

	render() {

		$("#load_area").hide();

		var items = this.state.posts;
		var secs = this.state.sec;
		var acyear = this.state.accyear;
		var grp = this.state.groups;

		/** set type select box **/
		this.type = [
			{ value: '', name: 'Select' },
			{ value: 'Student', name: 'Student' },
			{ value: 'Employee', name: 'Employee' }
		];

		/** set type select box **/
		this.gtype = [
			{ value: '', name: 'Select' },
			{ value: 'student', name: 'Student' },
			{ value: 'staff', name: 'Staff' }
		];

		/** map Section value to react multi select **/
		var val = this.state.sec.map(function (e, key) {
			return (
				{ value: e.section, label: e.secs }
			);
		});

		/** map Class value to react multi select **/
		var clss = this.state.posts.map(function (e, key) {
			return (
				{ value: e.id, label: e.class }
			);
		});

		/** map Group value to react multi select **/
		var grps = this.state.groups.map(function (e, key) {
			return (
				{ value: e.id, label: e.groupname }
			);
		});

		/** map Student value to react multi select **/
		var stud1 = this.state.studdet.map(function (e, key) {
			return (
				{ value: e.regno, label: e.stdname }
			);
		});

		/** map Group Member value to react multi select **/
		var grpmem = this.state.grpmembers.map(function (e, key) {
			return (
				{ value: e.memberid, label: e.membername }
			);
		});

		/** map Department value to react multi select **/
		var dept = this.state.depart.map(function (e, key) {
			return (
				{ value: e.id, label: e.designation }
			);
		});

		$('#msgarea').keyup(function () {

			var chars = this.value.length;
			if ($("#isUnicode1").prop("checked")) {
				var messages1 = Math.ceil(chars / 70),
					remaining1 = messages1 * 70 - (chars % (messages1 * 70) || messages1 * 70);
			}
			else {
				var messages1 = Math.ceil(chars / 160),
					remaining1 = messages1 * 160 - (chars % (messages1 * 160) || messages1 * 160);
			}

			$("#remaining1").text(remaining1 + ' characters remaining ');
			$("#messages1").text(messages1 + ' message(s)')

		});

		$('#sinmsgarea').keyup(function () {

			var chars = this.value.length;
			if ($("#isUnicode").prop("checked")) {
				var messages = Math.ceil(chars / 70),
					remaining = messages * 70 - (chars % (messages * 70) || messages * 70);
			}
			else {
				var messages = Math.ceil(chars / 160),
					remaining = messages * 160 - (chars % (messages * 160) || messages * 160);
			}

			$("#remaining").text(remaining + ' characters remaining ');
			$("#messages").text(messages + ' message(s)')

		});

		if (this.state.type == 'Student') {

			$("#countid").html(this.state.stdcount + ' ' + 'Students');
			$("#countid1").html(this.state.stdcountapp + ' ' + 'Push Notification');
		}

		if (this.state.type == 'Employee') {

			$("#countid").html(this.state.empcount + ' ' + 'Employees');
			$("#countid1").html(this.state.empcountapp + ' ' + 'Push Notification');
		}

		if (this.state.sendway == 3) {

			$("#inline-way3").prop("checked", true);
			$("#inline-way2").prop("checked", false);
			$("#inline-way1").prop("checked", false);
		}
		if (this.state.sendway == 2) {

			$("#inline-way2").prop("checked", true);
			$("#inline-way1").prop("checked", false);
			$("#inline-way3").prop("checked", false);
		}
		if (this.state.sendway == 1) {

			$("#inline-way1").prop("checked", true);
			$("#inline-way2").prop("checked", false);
			$("#inline-way3").prop("checked", false);
		}

		let isSingleEnable = true;
		if (this.state.singlemessage == '' || this.state.mobile == '') {
			isSingleEnable = true;
		} else {
			isSingleEnable = false;
		}

		let isEnable = true;
		if ($("#msgarea").val() == '') {
			isEnable = true;
		} else {
			isEnable = false;
		}

		let maxLength1 = '460';
		if (this.state.isUnicode1 == 1) {
			maxLength1 = '190';
		}

		let singlemaxlength = '460';
		if (this.state.isUnicode == 1) {
			singlemaxlength = '190';
		}

		return (
			<div>
				<MessagePage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<form action="" method="post" role="form" id="smsform" encType="multipart/form-data">
						<Row>
							<Col md="7">
								<Card>
									<CardHeader>
										<strong>Group & Single SMS</strong>&nbsp;&nbsp;&nbsp;&nbsp;
										Academic Year : &nbsp;&nbsp;
										<select name="acyear" onChange={this.onAcYearChange} required id="year">
											<option value="">Select Academic Year</option>
											{
												acyear.map(function (item) {
													return <option value={item.id}>{item.value}</option>;
												})
											}
										</select>
									</CardHeader>
									<CardBody>
										<Row>
											<Col md="12" id="smsleft">
												<div id="sendway">
													<FormGroup check inline>
														<Input className="form-check-input" type="radio" id="inline-way1" name="sendway" onChange={this.onSendChange} value="1" />
														<Label className="form-check-label" check htmlFor="inline-radio1">SMS</Label>
													</FormGroup>
													<FormGroup check inline>
														<Input className="form-check-input" type="radio" id="inline-way2" name="sendway" onChange={this.onSendChange} value="2" />
														<Label className="form-check-label" check htmlFor="inline-radio1">Push Notifications</Label>
													</FormGroup>
													<FormGroup check inline>
														<Input className="form-check-input" type="radio" id="inline-way3" name="sendway" onChange={this.onSendChange} value="3" />
														<Label className="form-check-label" check htmlFor="inline-radio3">SMS & Push Notifications</Label>
													</FormGroup>
												</div>
												<br />
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio7" name="radi" onChange={this.onOptChange} value="7" />
													<Label className="form-check-label" check htmlFor="inline-radio1">Group</Label>
												</FormGroup>
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio1" name="radi" onChange={this.onOptChange} value="1" />
													<Label className="form-check-label" check htmlFor="inline-radio1">Class</Label>
												</FormGroup>
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio2" name="radi" onChange={this.onOptChange} value="2" />
													<Label className="form-check-label" check htmlFor="inline-radio1">Section</Label>
												</FormGroup>
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio3" name="radi" onChange={this.onOptChange} value="3" />
													<Label className="form-check-label" check htmlFor="inline-radio3">Student</Label>
												</FormGroup>
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio6" name="radi" onChange={this.onOptChange} value="6" />
													<Label className="form-check-label" check htmlFor="inline-radio6">Designation</Label>
												</FormGroup>
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio4" name="radi" onChange={this.onOptChange} value="4" />
													<Label className="form-check-label" check htmlFor="inline-radio4">Common to All</Label>
												</FormGroup>
												<FormGroup check inline>
													<Input className="form-check-input" type="radio" id="inline-radio5" name="radi" onChange={this.onOptChange} onClick={this.toggle} value="5" />
													<Label className="form-check-label" check htmlFor="inline-radio5">Others</Label>
												</FormGroup>
												<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
													<ModalHeader toggle={this.toggle}>Others</ModalHeader>
													<ModalBody>
														<Row>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Mobile</Label>
																</FormGroup>
															</Col>
															<Col md="10">
																<FormGroup>
																	<Input type="text" name="mobile" id="singleMobile" onChange={this.onSingleChange} placeholder="Multiple numbers separated by comma (,)" />
																</FormGroup>
															</Col>
														</Row>
														<Row>
															<Col md="2">
																<FormGroup>
																	<Label htmlFor="name">Message</Label>
																</FormGroup>
															</Col>
															<Col md="10">
																<FormGroup>
																	<Input type="textarea" name="singlemessage" id="sinmsgarea" maxLength={singlemaxlength} onChange={this.onSingleChange} rows="5" placeholder="Type Message Here" required />
																	<span id="remaining">160 characters remaining </span>
																	<span id="messages">1 message(s)</span>
																</FormGroup>
																<FormGroup check inline>
																	<Label className="form-check-label" check htmlFor="inline-checkbox1">Unicode Message</Label>&nbsp;&nbsp;&nbsp;
																	<Input className="form-check-input" type="checkbox" id="isUnicode" onChange={this.onChkChange1} name="isUnicode" />
																</FormGroup>
															</Col>
														</Row>
													</ModalBody>
													<ModalFooter>
														<Button size="sm" color="primary" onClick={this.onSubmit} disabled={isSingleEnable}><i className="fa fa-dot-circle-o"></i> Send</Button>
														<Button size="sm" color="secondary" onClick={this.toggle}>Cancel</Button>
													</ModalFooter>
												</Modal>
											</Col>
										</Row><br></br>
										{this.state.radi == '7' ?
											<Row className="mess" id="grp">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Group</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<select name="grps" onChange={this.handleGroupChange} className="form-control" id="grps">
															<option value="">Select Group</option>
															{
																grp.map(function (item) {
																	return <option value={item.id}>{item.groupname}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
											</Row> : ''}
										{this.state.radi == '7' ?
											<Row className="mess">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Type</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<select name="gtype" className="form-control" onChange={this.onChange} required id="gtype">
														{this.gtype.map((e, key) => {
															return <option key={key} value={e.value}>{e.name}</option>;
														})}
													</select>
												</Col>
											</Row> : ''}
										{this.state.radi == '7' ?
											<Row className="mess">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Select {this.state.gtype}</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<Select value={this.state.grpmember} id="gmem" onChange={this.handleMemChange.bind(this)} multi options={grpmem} />
												</Col>
											</Row> : ''}
										{this.state.radi == '1' ?
											<Row className="mess" id="clsmulti">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Select Class</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<Select value={this.state.classs} id="classs" onChange={this.handleSelectChange} multi options={clss} />
													</FormGroup>
												</Col>
											</Row> : ''}
										{this.state.radi == '2' || this.state.radi == '3' ?
											<Row className="mess" id="cls">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Select Class</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<select name="cls" onChange={this.onClssChange} className="form-control" id="clas">
															<option value="">Select Class</option>
															{
																items.map(function (item) {
																	return <option value={item.id}>{item.class}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
											</Row> : ''}
										{this.state.radi == '3' ?
											<Row className="mess" id="sect">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Section</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<select name="section" onChange={this.onChange} className="form-control" id="secs">
															<option value="">Select Section</option>
															{
																secs.map(function (item) {
																	return <option value={item.section}>{item.secs}</option>;
																})
															}
														</select>
													</FormGroup>
												</Col>
											</Row> : ''}
										{this.state.radi == '2' ?
											<Row className="mess" id="sectmulti">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Section</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<Select value={this.state.value} id="sectio" onChange={this.handleChange} multi options={val} />
													</FormGroup>
												</Col>
												<Col md="4">
												</Col>
												<Col md="3">
													<FormGroup>
														<Input type="radio" id="inline-hw" name="typecheck" onChange={this.onChange} value="homework" required />
														<Label htmlFor="inline-hw">Home Work</Label>
													</FormGroup>
												</Col>
												<Col md="3">
													<FormGroup>
														<Input type="radio" id="inline-cust" name="typecheck" onChange={this.onChange} value="custom" required />
														<Label htmlFor="inline-cust">Custom</Label>
													</FormGroup>
												</Col>
												<Col md="2"></Col>
											</Row> : ''}
										{this.state.radi == '3' ?
											<Row className="mess" id="stude">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Student</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<Select value={this.state.student} id="stud" onChange={this.handleStudChange} multi options={stud1} />
													</FormGroup>
												</Col>
												<Col md="2">
													<FormGroup>
														<input type="checkbox" id="chkStudAll" onChange={this.onChkStudChange.bind(this)} />&nbsp;All
													</FormGroup>
												</Col>
											</Row> : ''}
										{this.state.radi == '6' ?
											<Row className="mess" id="depart">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Designation</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<FormGroup>
														<Select value={this.state.department} id="depat" onChange={this.handleDeptChange} multi options={dept} />
													</FormGroup>
												</Col>
											</Row> : ''}
										{this.state.radi == '4' ?
											<Row className="mess" id="type">
												<Col md="3">
													<FormGroup>
														<Label htmlFor="name">Type</Label>
													</FormGroup>
												</Col>
												<Col md="6">
													<select name="type" className="form-control" onChange={this.onChange} required id="utype">
														{this.type.map((e, key) => {
															return <option key={key} value={e.value}>{e.name}</option>;
														})}
													</select>
												</Col>
											</Row> : ''}
										<Row className="countmem">
											{this.state.sendway != 2 ? <span id="countid" style={{ color: 'green', fontWeight: 'bold' }}></span> : ''}&nbsp;&nbsp;&nbsp;
							 {this.state.sendway != 1 ? <span id="countid1" style={{ color: '#0c84af', fontWeight: 'bold' }}></span> : ''}
										</Row>
										<br></br>
										<Col md="3"></Col>
										<Col md="9">
											<FormGroup check inline id="checkname">
												<Input className="form-check-input" onChange={this.onNameChange} type="checkbox" id="namecheck" name="namecheck" />&nbsp;&nbsp;&nbsp;
								<Label className="form-check-label" check htmlFor="inline-checkbox1" > With Name</Label>
											</FormGroup>
										</Col>
										<Row className="mess">
											<Col md="3">
												<FormGroup>
													<Label htmlFor="name">Message</Label>
												</FormGroup>
											</Col>
											<Col md="6">
												<FormGroup>
													<Input type="textarea" name="textmessage" id="msgarea" maxLength={maxLength1} onChange={this.onChange} rows="5" placeholder="Type Message Here" required />
													<span id="remaining1">160 characters remaining </span>
													<br />
													<span id="messages1">1 message(s)</span>
												</FormGroup>
												<FormGroup check inline>
													<Label className="form-check-label" check htmlFor="inline-checkbox1" > Is Tamil Message ?</Label>&nbsp;&nbsp;&nbsp;
									<Input className="form-check-input" onChange={this.onChkChange} type="checkbox" id="isUnicode1" name="isUnicode1" />
												</FormGroup>
											</Col>
										</Row>
									</CardBody>
									<CardFooter>
										<span id="some_div"><Button size="sm" className="btn-right" disabled={isEnable} onClick={this.onSubmit} color="primary"><i className="fa fa-dot-circle-o"></i> Send</Button></span><span id="time" className="btn-right"></span>
									</CardFooter>
								</Card>
							</Col>
							<Col md="5">
								<Card>
									<CardHeader>
										<strong>SMS Templates</strong>
									</CardHeader>
									<CardBody>
										<Col md="12">
											<Table responsive bordered >
												<thead>
													<tr>
														<th>S.No</th>
														<th>Message</th>
														<th>SMS Count</th>
														<th>Manage</th>
													</tr>
												</thead>
												<tbody>
													{this.state.smstemp.map((item, index) =>
														<tr key={index}>
															<td>{index + 1}</td>
															<td>{item.message}</td>
															<td>{item.count}</td>
															<td>
																<button type="button" name="editsub" className="btn btn-info btn-sm" onClick={() => this.onAddTemp(item.message)} ><i className="fa fa-plus"></i></button>
																&nbsp;&nbsp;
											<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} ><i className="fa fa-remove"></i></button>
															</td>
														</tr>
													)}
												</tbody>
											</Table>
										</Col>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</form>
				</div>
			</div>
		)
	}
}

export default Group;


// WEBPACK FOOTER //
// ./src/message/Group/Group.js